import { Component, OnInit } from '@angular/core';

import { DashboardServiceService } from '../../services/dashboard-service.service';
import { MatDialog } from '@angular/material/dialog';
import { UnsubscribeModalComponent } from '../../modals/unsubscribe-modal/unsubscribe-modal.component';
import { EndSubscriptionAddOnsComponent } from '../../modals/end-subscription-add-ons/end-subscription-add-ons.component';
import { GlobalService } from 'src/app/services/global.service';
import { MapServiceService } from 'src/app/modules/map/services/Map-service/map-service.service';

@Component({
  selector: 'app-add-ons',
  templateUrl: './add-ons.component.html',
  styleUrls: ['./add-ons.component.css'],
})
export class AddOnsComponent implements OnInit {
  isLoaded: any;
  isEdit: any;
  collaborators: any = [];
  outReach: any;
  endOutreach: any;
  originalValue: any = [];
  endCheck: any;
  changeValue: any = [];
  data: any;
  text: any;
  showAccessMessage: any;
  userHaveAccess: any;
  constructor(
    private mapService: MapServiceService,
    public dashboardService: DashboardServiceService,
    private dialog: MatDialog,
    private global: GlobalService
  ) {
    //
  }

  ngOnInit(): void {
    //handle dynamic modal
    this.mapService.dynamicModalCheck(
      '',
      this.mapService.isLiveShareLink,
      true,
      false
    );
    if (this.dashboardService.mapsAndProfile != null) {
      this.updateData();
    }
    this.dashboardService.dataLoaded.subscribe(() => {
      this.updateData();
    });

    this.dashboardService.clearData.subscribe(() => {
      this.global.toggleLoader(true);

      setTimeout(() => {
        this.dashboardService.getDashboardData().subscribe((res) => {
          this.dashboardService.mapsAndProfile = res;
          this.isEdit = false;
          this.updateData();
        });
      }, 100);
    });
  }

  //render data in html based on scenarios
  updateData(): void {
    this.originalValue = [];
    this.changeValue = [];
    this.collaborators = [];
    this.endOutreach = '';
    this.data = this.dashboardService.mapsAndProfile.adds_on;
    this.text = this.dashboardService.mapsAndProfile.add_ons_text;
    if (this.data.length != 0) {
      for (let i = 0; i < this.data.length; i++) {
        if (this.data[i].name == 'Collaborator Seats') {
          if (
            this.data[i].status == 'active' ||
            this.data[i].status == 'canceled'
          ) {
            this.userHaveAccess = true;
          }
          this.collaborators.push(this.data[i]);
          this.originalValue[i] = this.collaborators[i].current;
          this.changeValue[i] = this.originalValue[i];
          this.changeValue[i] = this.originalValue[i];

          if (
            this.data[i].status == 'canceled' ||
            this.data[i].cancel_seat !== '0'
          ) {
            this.showAccessMessage = true;
          }
        } else {
          this.outReach = this.data[i];
          if (this.outReach.status == 'canceled') {
            this.showAccessMessage = true;
          }
          if (
            this.outReach.status == 'canceled' ||
            this.outReach.status == 'active'
          ) {
            this.userHaveAccess = true;
          }
        }
      }

      this.endCheck = false;
    } else {
      this.data = null;
    }
    this.isLoaded = true;
  }

  edit(): void {
    this.isEdit = true;
  }
  back(): void {
    this.isEdit = false;
  }

  //end out reach
  onChange(event: any): void {
    if (event.target.checked) {
      this.endOutreach = event.target.value;
      this.endCheck = event.target.value;
    } else {
      this.endOutreach = '';
      this.endCheck = event.target.value;
    }
  }

  //increase seat to end
  increaseValue(value: any, index: any): void {
    if (value[index] < this.originalValue[index]) {
      this.changeValue[index] += 1;
    }
  }

  //decrease seat to end
  decreaseValue(value: any, index: any): void {
    if (value[index] > 0) {
      this.changeValue[index] = this.changeValue[index] - 1;
    }
  }

  //end out reach or seats subscription
  submit(e: any): void {
    e.preventDefault();
    let decide: any;
    for (let i = 0; i < this.changeValue.length; i++) {
      if (this.changeValue[i] != this.originalValue[i]) {
        decide = true;
        break;
      }
    }
    for (let i = 0; i < this.collaborators.length; i++) {
      this.collaborators[i].original = this.originalValue[i];
      this.collaborators[i].change = this.changeValue[i];
    }
    if (decide || this.endOutreach) {
      this.dialog.open(EndSubscriptionAddOnsComponent, {
        disableClose: true,
        data: {
          message: true,
          completeData: this.collaborators,
          outReach: this.endOutreach,
        },
        panelClass: 'app-full-bleed-dialog',
        backdropClass: 'bdrop',
      });
    } else {
      this.dialog.open(UnsubscribeModalComponent, {
        disableClose: true,
        data: { message: false },
        panelClass: 'app-full-bleed-dialog',
        position: {
          top: '10%',
          left: '70%',
        },
        backdropClass: 'bdrop',
      });
    }
  }
}
